import script from "./DynamicOptions.vue?vue&type=script&setup=true&lang=ts"
export * from "./DynamicOptions.vue?vue&type=script&setup=true&lang=ts"

import "./DynamicOptions.vue?vue&type=style&index=0&id=05f5e820&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05f5e820"]])

export default __exports__